<template>
  <BottomSheet :show="show" @close="$emit('close')">
    <div class="flex flex-col items-center justify-center px-6 pt-2 pb-8">
      <div class="bg-primary rounded-full w-20 h-20 flex items-center justify-center shadow-lg -mt-12 mb-4">
        <i class="bx bx-check text-white text-4xl"></i>
      </div>
      <h2 class="text-2xl font-bold text-center mb-2 mt-2">Profilo salvato!</h2>
      <p class="text-gray-500 text-center mb-6">
        Il tuo profilo è stato salvato con successo.<br>
        Ora puoi candidarti ai casting!
      </p>
      <div class="mt-auto pb-8 w-full">
        <CuButton primary class="w-full" @click="$emit('continue')">
          Continua
          <span class="ml-2">&rarr;</span>
        </CuButton>
      </div>
    </div>
  </BottomSheet>
</template>

<script>
import BottomSheet from './BottomSheet.vue'
import CuButton from '../cu/CuButton.vue'

export default {
  name: "ProfileSavedSheet",
  components: { BottomSheet, CuButton },
  props: {
    show: { type: Boolean, default: false }
  }
}
</script>
